export function clampPaginationPage(value, totalPages) {
  const lastPage = Math.max(1, Number(totalPages) || 1);
  const page = Number.parseInt(value, 10);
  if (!Number.isFinite(page)) return 1;
  return Math.min(Math.max(page, 1), lastPage);
}

export function pageButtonCapacity(
  availableWidth,
  { buttonWidth = 38, gap = 5, fallback = 5 } = {},
) {
  const width = Number(availableWidth);
  if (!Number.isFinite(width) || width <= 0) return fallback;
  return Math.max(1, Math.floor((width + gap) / (buttonWidth + gap)));
}

export function visiblePageNumbers({ page, totalPages, capacity }) {
  const lastPage = Math.max(1, Number(totalPages) || 1);
  const currentPage = clampPaginationPage(page, lastPage);
  const visibleCount = Math.min(
    lastPage,
    Math.max(1, Math.floor(Number(capacity) || 1)),
  );
  let firstPage = currentPage - Math.floor(visibleCount / 2);

  firstPage = Math.max(1, firstPage);
  firstPage = Math.min(firstPage, lastPage - visibleCount + 1);

  return Array.from(
    { length: visibleCount },
    (_, index) => firstPage + index,
  );
}
